export default __webpack_public_path__ + "static/ibm-ff08c7dd2a01178e50355a671ddbfe11.svg";